class CategoryViewSwitch
{
    constructor()
    {
        this.page = document.querySelector('#category');
        this.body = document.querySelector('body');
        this.content = document.querySelector('#content');
    }

    init()
    {
        if (this.page === null)
        {
            return;
        }

        this.content.addEventListener(orion.constants.EventFiltersMarkupReplaced, this.initButtons.bind(this));

        this.initButtons();
    }

    initButtons()
    {
        document.querySelector('.js-tiles-view-button').addEventListener('click', (e) =>
        {
            e.preventDefault();
            this.render('tiles');
        });

        document.querySelector('.js-list-view-button').addEventListener('click', (e) =>
        {
            e.preventDefault();
            this.render('list');
        });
    }

    getCookie(cookieName)
    {
        let value = '; ' + document.cookie;
        let parts = value.split('; ' + cookieName + '=');

        if (parts.length === 2)
        {
            return parts.pop().split(';')
                .shift();
        }
    }

    setCookie(viewType)
    {
        let expires = new Date();

        expires.setTime(expires.getTime() + (30 * 24 * 60 * 60 * 1000));
        document.cookie = 'viewType=' + viewType + ';path=/;expires=' + expires.toUTCString();
    }

    render(viewType)
    {
        this.body.classList.add('processing');
        this.setCookie(viewType);
        location.reload();
    }
}

let categoryViewSwitch = new CategoryViewSwitch();

categoryViewSwitch.init();
